import { render } from "./SolutionPage.vue?vue&type=template&id=8c4ce2b8&scoped=true"
import script from "./SolutionPage.vue?vue&type=script&lang=js"
export * from "./SolutionPage.vue?vue&type=script&lang=js"

import "./SolutionPage.vue?vue&type=style&index=0&id=8c4ce2b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c4ce2b8"]])

export default __exports__